/* tslint:disable:variable-name */
import { IndexedDbModel } from '../../../shared/indexedDb/indexedDb.model';
import { BaseDataValueApi } from './base-data-value.api-model';

export class BaseDataIndexedDbModel extends IndexedDbModel {
  // Configuration
  public entity = 'base-data';
  public table = 'base_data';
  public schema = '++id, module_id, key';
  public sync = true;

  // Fields
  public module_id?: string;
  public key: string;
  public editable_by_tenant: boolean;
  public values: BaseDataValueApi[];
  public attributes: { value: string; [key: string]: string }[];

  // Constructor
  constructor(attributes: Partial<BaseDataIndexedDbModel>) {
    super(attributes);
  }

  public async init(): Promise<void> {
    await BaseDataIndexedDbModel.query().where({ base_data_key_id: this.id }).toArray().then(result => {
      this.values = result;
    });
  }
}
